// Séparation en deux univers Chantier / Interventions (PLAN_SEPARATION_UNIVERS.md).
// Flag de déploiement compilé au build : absent ou ≠ "true" → app strictement
// identique à avant (aucune route /interventions/*, aucun sélecteur).
export const UNIVERSES_ENABLED =
  process.env.REACT_APP_FEATURE_UNIVERSES === "true";

// Dernier univers visité (même famille que nav-collapsed / nav-sec-*).
export const LAST_UNIVERSE_KEY = "universe-last";

export function rememberUniverse(universe) {
  try {
    localStorage.setItem(LAST_UNIVERSE_KEY, universe);
  } catch {
    // stockage indisponible (navigation privée) : préférence simplement oubliée
  }
}
